














































import { Component, Vue } from 'vue-property-decorator';
import { OutputInfo } from '@/libs/com/MetaPattern/MDA/Designer/Base/OutputInfo';
import { ValidationResult } from '@/api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { EnumErrorLevel, EnumErrorLevelMD } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { MDService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDService';
import { Message } from 'element-ui';

@Component({
  components: {
  }
})
export default class MessageScope extends Vue {
  curTab = 'errors';
  isExpend = true;
  requirement = '';
  aiLoading = false;
  created() {
    // 挂载事件
    EventBus.$on('messageScope:command', (command: string, param: boolean) => {
      if (command === 'expend') {
        this.isExpend = param as boolean;
        const tabs = document.getElementsByClassName('mseesageTab') as any;
        tabs.forEach((element: any) => {
          element.style.height = (this.isExpend ? 160 : 0) + 'px';
        });
      }
    });
  }

  beforeDestroy() {
    // 销毁事件
  }

  getErrorLevel(itemValue: number) {
    return EnumErrorLevelMD.getItemByValue(itemValue)?.displayName;
  }

  getErrorIcon(itemValue: number): string {
    let icon = '';
    const enumItem = EnumErrorLevelMD.getItemByValue(itemValue);
    if (enumItem.value === EnumErrorLevel.Error) {
      icon = 'el-icon-error';
    } else if (enumItem.value === EnumErrorLevel.Warning) {
      icon = 'el-icon-warning';
    } else if (enumItem.value === EnumErrorLevel.Info) {
      icon = 'el-icon-info';
    }
    return icon;
  }

  getElementDisplayName(designId: string) {
    const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === designId);
    if (element) {
      return element.displayName;
    }
    return '';
  }

  viewElement(row: any, column: any, cell: any, event: any) {
    if (row) {
      EventBus.$emit('selectElement', row.containerDesignId, row.designId);
      // TODO: 用事件抛出当前要选中的元素：containerDesignId, designId
      // Draw接收以后选中
      // console.log(`${this.getElementDisplayName(row.containerDesignId)}-${this.getElementDisplayName(row.designId)}`);
    }
  }

  get tableData(): Array<ValidationResult> {
    return this.$store.state.ModuleMD.validationErrors;
  }

  get outputs(): Array<OutputInfo> {
    return this.$store.state.ModuleMD.outputMessages;
  }

  generateModel() {
    if (this.requirement !== '') {
      this.aiLoading = true;
      MDService.GenerateBEComponentAsync(this.requirement).then((component) => {
        this.$store.dispatch('ModuleMD/setElementAction', { element: component, componentDesignId: component.designId });
        EventBus.$emit('openDoc', component);
      }).catch((err) => {
        Message.error('AI调用发生错误：' + err);
      }).finally(() => {
        this.aiLoading = false;
      });
    }
  }
}
